export class PICBarChart {
    constructor(options) {
        this.options = options;
        this.canvas = options.canvas;
        let hest = this.canvas.getContext("2d");
        if (hest)
            this.ctx = hest;
        this.colors = options.colors;
        this.titleOptions = options.titleOptions;
        this.maxValue = Math.max(...Object.values(this.options.data));
    }
    drawLine(ctx, startX, startY, endX, endY, color) {
        ctx.save();
        this.straddlePixels(true);
        ctx.strokeStyle = color;
        ctx.beginPath();
        ctx.moveTo(startX, startY);
        ctx.lineTo(endX, endY);
        this.straddlePixels(false);
        ctx.stroke();
        ctx.restore();
    }
    drawBar(ctx, upperLeftCornerX, upperLeftCornerY, width, height, color) {
        ctx.save();
        this.straddlePixels(true);
        ctx.fillStyle = color;
        ctx.fillRect(upperLeftCornerX, upperLeftCornerY, width, height);
        this.straddlePixels(false);
        ctx.restore();
    }
    drawGridLines() {
        var canvasActualHeight = this.canvas.height - this.options.padding * 2;
        var canvasActualWidth = this.canvas.width - this.options.padding * 2;
        var gridValue = 0;
        while (gridValue <= this.maxValue) {
            var gridY = canvasActualHeight * (1 - gridValue / this.maxValue) +
                this.options.padding;
            this.drawLine(this.ctx, 0, gridY, this.canvas.width, gridY, this.options.gridColor);
            this.drawLine(this.ctx, 15, this.options.padding / 2, 15, gridY + this.options.padding / 2, this.options.gridColor);
            // Writing grid markers 
            this.ctx.save();
            this.straddlePixels(true);
            this.ctx.fillStyle = this.options.gridColor;
            this.ctx.textBaseline = "bottom";
            this.ctx.font = "bold 10px Arial";
            this.ctx.fillText("" + gridValue, 0, gridY - 2);
            this.straddlePixels(false);
            this.ctx.restore();
            gridValue += this.options.gridStep;
        }
    }
    drawBars() {
        var canvasActualHeight = this.canvas.height - this.options.padding * 2;
        var canvasActualWidth = this.canvas.width - this.options.padding * 2;
        var barIndex = 0;
        var numberOfBars = Object.keys(this.options.data).length;
        var barSize = canvasActualWidth / numberOfBars;
        var values = Object.values(this.options.data);
        for (let val of values) {
            var barHeight = Math.round((canvasActualHeight * val) / this.maxValue);
            this.drawBar(this.ctx, this.options.padding + barIndex * barSize, this.canvas.height - barHeight - this.options.padding, barSize, barHeight, this.colors[barIndex % this.colors.length]);
            barIndex++;
        }
    }
    drawLabel() {
        var _a, _b, _c, _d, _e, _f, _g;
        this.ctx.save();
        this.ctx.textBaseline = "bottom";
        this.ctx.textAlign = (_a = this.titleOptions) === null || _a === void 0 ? void 0 : _a.align;
        this.ctx.fillStyle = (_b = this.titleOptions) === null || _b === void 0 ? void 0 : _b.fill;
        this.ctx.font = `${(_c = this.titleOptions) === null || _c === void 0 ? void 0 : _c.font.weight} ${(_d = this.titleOptions) === null || _d === void 0 ? void 0 : _d.font.size} ${(_e = this.titleOptions) === null || _e === void 0 ? void 0 : _e.font.family}`;
        let xPos = this.canvas.width / 2;
        if (((_f = this.titleOptions) === null || _f === void 0 ? void 0 : _f.align) == "left") {
            xPos = 10;
        }
        if (((_g = this.titleOptions) === null || _g === void 0 ? void 0 : _g.align) == "right") {
            xPos = this.canvas.width - 10;
        }
        if (this.options.seriesName)
            this.ctx.fillText(this.options.seriesName, xPos, this.canvas.height);
        this.ctx.restore();
    }
    drawLegend() {
        var _a;
        let pIndex = 0;
        let ul = document.createElement("ul");
        (_a = this.options.legend) === null || _a === void 0 ? void 0 : _a.append(ul);
        for (let ctg of Object.keys(this.options.data)) {
            let li = document.createElement("li");
            li.style.listStyle = "none";
            li.style.borderLeft =
                "20px solid " + this.colors[pIndex % this.colors.length];
            li.style.padding = "5px";
            li.textContent = ctg;
            ul.append(li);
            pIndex++;
        }
    }
    straddlePixels(isFirst) {
        var _a, _b;
        (_a = this.options.ctx) === null || _a === void 0 ? void 0 : _a.translate(0.5, 0.5);
        (_b = this.options.ctx) === null || _b === void 0 ? void 0 : _b.translate(-0.5, -0.5);
    }
    clearCanvas() {
        var _a;
        (_a = this.options.ctx) === null || _a === void 0 ? void 0 : _a.clearRect(0, 0, this.canvas.width, this.canvas.height);
    }
    calculateAndSetCanvasSize() {
        this.canvas.height = Object.keys(this.options.data).length * this.options.padding;
    }
    draw() {
        this.calculateAndSetCanvasSize();
        this.drawGridLines();
        this.drawBars();
        this.drawLabel();
        this.drawLegend();
    }
}
//# sourceMappingURL=PICBarChart.js.map